export default __webpack_public_path__ + "static/media/next_arrow_white.f5983a3a.svg";